/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=62cb9e57&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=62cb9e57&scoped=true&lang=css"

import exportComponent from "E:\\web3DProject\\web3DHuman2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62cb9e57"]])

export default __exports__